var _ellipse, _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 5.5,
    width: 28,
    height: 20,
    rx: 1.5,
    fill: "white",
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4C9.5 3.17157 10.1716 2.5 11 2.5H18.5C19.0523 2.5 19.5 2.94772 19.5 3.5C19.5 4.60457 20.3954 5.5 21.5 5.5C22.0523 5.5 22.5 5.94772 22.5 6.5V8.5H9.5V4Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7C10 6.44772 10.4477 6 11 6H36C36.5523 6 37 6.44772 37 7V9H10V7Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9209 14.7754C10.9453 14.7754 10.3828 14.0459 10.3828 12.6484C10.3828 11.2773 10.9541 10.4336 11.9209 10.4336C12.8877 10.4336 13.4678 11.2773 13.4678 12.6572C13.4678 14.0547 12.8965 14.7754 11.9209 14.7754ZM11.7803 21.1562C14.9004 21.1562 17.0537 19.7324 17.0537 17.4209V7.79688H13.4502V9.5459H13.3799C13.002 8.45605 11.9473 7.65625 10.5322 7.65625C8.11523 7.65625 6.69141 9.50195 6.69141 12.6221C6.69141 15.6631 8.21191 17.377 10.4795 17.377C11.9297 17.377 13.0635 16.665 13.3799 15.6455H13.4502V17.5088C13.4502 18.3262 12.9316 18.8799 11.8594 18.8799C11.0508 18.8799 10.4795 18.5459 10.374 18.0801H6.91113C7.06055 19.8818 8.83594 21.1562 11.7803 21.1562Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7656 18.8876C34.7656 18.9387 34.7576 18.9855 34.7576 19.0365C36.5777 19.0408 38 20.5934 38 22.5076C38 24.4176 36.5174 26 34.7094 26H30.6513L23.6 25.9957C21.6112 25.9957 20 24.29 20 22.2013C20 20.5424 21.0205 19.2067 22.4348 18.6962C22.6277 17.5051 23.6121 16.514 24.8013 16.514C25.1911 16.514 25.5527 16.6118 25.8781 16.782C26.6254 15.14 28.2205 14 30.0728 14C32.6402 14 34.7656 16.1865 34.7656 18.8876Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6567 22L29.8283 24.8284L29.1212 24.1213L29.1212 24.1213L26.9999 22L27.707 21.2928L29.3283 22.9142L29.3283 17L30.3283 17L30.3283 22.9142L31.9496 21.2929L32.6567 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3e50acf21922acb3b0a4cef1ec03b52d.svg";
export { ForwardRef as ReactComponent };